import { Component, DoCheck, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { ApiService } from 'src/app/api/api.service';
import { AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { CreatePage as TimeAndBillingCreatePage } from 'src/app/time-and-billing/create/create.page';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-bottom-navbar',
  templateUrl: './bottom-navbar.component.html',
  styleUrls: ['./bottom-navbar.component.scss'],
})
export class BottomNavbarComponent implements OnInit, DoCheck {


  total_seconds = 0;
  is_running = false;
  date = null;
  interval: any;

  // The timer UI (bottom-navbar.component.html) is turned off, so the timer isn't resumed from its cookies here -
  // with no way left to stop it, a leftover "timer_running" cookie would otherwise keep a 1-second interval going
  // that re-ran change detection across the whole app every second. Call globalService.CheckTimer() again if the
  // timer UI comes back.
  constructor(
    private cookieService: CookieService,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    private apiService: ApiService,
    private modalController: ModalController,
    private alertController: AlertController
  ) {
    route.params.subscribe(() => {
      // Without time tracking there is no timer UI to stop it, so don't resume one from its cookies
      if (this.globalService.TimeAndBillingEnabled) this.globalService.CheckTimer();
    });
  }

  ngOnInit() {}

  // "Client - Project - Task" for whatever the timer is running for (empty when it isn't tied to anything)
  timer_label = '';
  private timer_label_key = '';

  ngDoCheck() {
    const key = this.globalService.timer_project ? `${this.globalService.timer_project_type}|${this.globalService.timer_project.guid}` : '';
    if (key === this.timer_label_key) return;
    this.timer_label_key = key;
    this.timer_label = '';
    if (key) this.ResolveTimerLabel(key);
  }

  private async ResolveTimerLabel(key: string) {
    const item = this.globalService.timer_project;
    const type = this.globalService.timer_project_type;
    let client = '', project = '', task = '';
    try {
      if (type === 'project') {
        const data: any = await this.apiService.get(`projects/${item.guid}`);
        const found = data?.success ? data.data?.[0] : null;
        client = found?.client_name || found?.company_name || '';
        project = found?.title || item.title || '';
      } else if (type === 'task') {
        const data: any = await this.apiService.get(`tasks/${item.guid}`);
        const found = data?.success ? data.data?.[0] : null;
        task = found?.title || item.title || '';
        client = found?.client_name || found?.company_name || '';
        const project_guid = found?.project_guid || item.project_guid;
        if (project_guid) {
          const project_data: any = await this.apiService.get(`projects/${project_guid}`);
          const found_project = project_data?.success ? project_data.data?.[0] : null;
          project = found_project?.title || '';
          client = client || found_project?.client_name || found_project?.company_name || '';
        }
      } else if (type === 'to do') {
        client = item.linked_name || '';
        task = item.title || '';
      } else {
        // missing information: the row already carries who it is for and its project
        client = item.client_entity_name || item.client_name || '';
        project = item.project_title || '';
        task = item.title || '';
      }
    } catch { /* the label is only a nicety - leave it as what we have */ }
    // The timer may have moved on to something else (or been discarded) while this was loading
    if (this.timer_label_key !== key) return;
    this.timer_label = [client, project, task].filter(part => part).join(' - ');
  }

  get timerRunning(): boolean {
    return !!this.globalService.interval;
  }

  get hasTime(): boolean {
    return this.globalService.total_seconds > 0;
  }

  StartTimer() {
    this.globalService.StartTimer();
  }

  PauseTimer() {
    this.globalService.StopTimer();
  }


  async ConfirmDiscardTimer() {
    const alert = await this.alertController.create({
      header: 'Discard Timer?',
      message: this.globalService.timer_project
        ? `The timer is currently running for the ${this.globalService.timer_project_type || 'project'} "${this.globalService.timer_project.title}". Are you sure you want to discard it?`
        : `Are you sure you want to discard the timer?`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        { text: 'Discard', role: 'destructive', handler: () => this.globalService.ResetTimer() }
      ]
    });
    await alert.present();
  }

  async StopAndLog() {
    this.globalService.StopTimer();
    const now = new Date();
    const start = this.globalService.GetTimerStart(now);

    const modal = await this.modalController.create({
      component: TimeAndBillingCreatePage,
      cssClass: 'large-modal',
      componentProps: {
        initial_start_time: start,
        initial_end_time: now,
        initial_worked_ms: this.globalService.total_seconds,
        reset_timer_on_save: true,
        project: this.globalService.timer_project || null
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data?.data?.success) this.globalService.ResetTimer();
    });
    return await modal.present();
  }

  async OpenManualPanel() {
    const modal = await this.modalController.create({
      component: TimeAndBillingCreatePage,
      cssClass: 'large-modal'
    });
    return await modal.present();
  }
}
